<template>
  <SettingComponentPage title="管理者の2要素認証" summary="管理者権限の方に、認証アプリの6桁を必須にできます。">
    <AdminMfaPolicySettings/>
  </SettingComponentPage>
</template>

<script>
import SettingComponentPage from './SettingComponentPage.vue'
import AdminMfaPolicySettings from '../AdminMfaPolicySettings.vue'

export default {
  name: 'AdminMfaEdit',
  components: { SettingComponentPage, AdminMfaPolicySettings }
}
</script>
